import { ReactTooltip, Text } from "./Tooltip.styled";

const Tooltip = ({ id, content, children }) => {
  const showTooltip = content?.length >= 10;

  return (
    <>
      <Text data-tooltip-id={id} data-tooltip-content={content}>
        {children}
      </Text>

      {showTooltip && (
        <ReactTooltip id={id} place="top-start" variant="light" opacity={1} />
      )}
    </>
  );
};

export default Tooltip;
